export const newspaperFiltersInitialState = {};
